module.exports = __webpack_public_path__ + "img/5.42614012.jpg";